<template>
  <div class="v-d-top">
    <div class="dice dice--pink">
      <router-link class="dice__content" :to="{ name: 'help' }">
        <p class="dice__content__text">
          <span class="dice__content__text__cell"> 需 </span>
          <span class="dice__content__text__cell"> 要 </span>
        </p>
        <p class="dice__content__text">
          <span class="dice__content__text__cell"> 協 </span>
          <span class="dice__content__text__cell"> 助 </span>
        </p>
      </router-link>
    </div>

    <router-link class="dice dice--purple" :to="{ name: 'donate-channel' }">
      <div class="dice__content">
        <p class="dice__content__text">
          <span class="dice__content__text__cell"> 我 </span>
          <span class="dice__content__text__cell"> 要 </span>
        </p>
        <p class="dice__content__text">
          <span class="dice__content__text__cell"> 捐 </span>
          <span class="dice__content__text__cell"> 款 </span>
        </p>
      </div>
    </router-link>

    <div class="top" @click="toTop">
      <img class="top__flower" src="@/assets/icon/icon_top_1.png" />
      <img class="top__root" src="@/assets/icon/icon_top_2.png" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Top',
  setup() {
    const toTop = () => {
      const scrollEle = document.querySelector('#app');
      if (scrollEle) {
        scrollEle.scrollTo({
          behavior: 'smooth',
          top: 0,
          left: 0,
        });
      }
    };

    return { toTop };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.v-d-top {
  position: fixed;
  right: 25px;
  bottom: 50px;
  z-index: 100;
  @include flex(flex-start, center, column);
}

.dice {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 2px solid $c-main;
  @include flex(center, center);

  &--pink {
    background-color: $c-dice--pink;
    margin-bottom: 10px;
  }

  &--purple {
    background-color: $c-dice--purple;
    margin-bottom: 35px;
  }

  &__content {
    width: 100%;
    height: 100%;
    @include padding(4px 6px);

    &__text {
      @include font-style($c-white, 12, 400, 1.2px, 13px);
      @include flex(center, center);
      // transform: scale(0.9);

      &__cell {
        display: inline-block;
        text-align: center;
        width: 13px;
        height: 13px;
      }
    }
  }
}

.top {
  position: relative;
  width: 40px;
  cursor: pointer;

  &__flower {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    z-index: 10;

    &:hover {
      + .top__root {
        transform: translate(-50%, 130%);
      }
    }
  }

  &__root {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -40%);
    width: 100%;
    transition: 0.4s;
  }
}

@media screen and (min-width: $portrait) {
  .v-d-top {
    bottom: 100px;
  }

  .dice {
    position: relative;
    width: 60px;
    height: 60px;
    border-radius: 10px;
    border: 3px solid $c-main;
    @include flex(center, center);

    &--pink {
      background-color: $c-dice--pink;
      margin-bottom: 15px;
    }

    &--purple {
      background-color: $c-dice--purple;
      margin-bottom: 70px;
    }

    &__content {
      width: 44px;
      height: 44px;
      @include padding(0px);

      &__text {
        @include font-style($c-white, 18, 400, 1.2px, 22px);
        @include flex(center, center);

        &__cell {
          display: inline-block;
          text-align: center;
          width: 22px;
          height: 22px;
        }
      }
    }
  }

  .top {
    width: 80px;
  }
}

@media screen and (min-width: $sm-pc) {
  .v-d-top {
    right: 78px;
  }
}
</style>
